import React, { PureComponent } from "react";

import { Query } from "react-apollo";
import styled from "styled-components";

import cityQuery from "../../queries/cityQuery.gql";
import Loading from "../../components/Loading/Loading";
import Emoji from "../../components/Emoji/Emoji";

const PageWrapper = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  height: 1200px;
  width: 1200px;
  overflow: hidden;
  background-color: #85c6e3;
  padding: 10px 0px;
  align-items: center;
  justify-content: space-around;
  background-image: url(${require("../../assets/images/sharebg.png")});
  background-size: cover;
  background-position: center;
`;

const PartyWrapper = styled.div`
  font-size: 300px;
  margin-top: 75px;
  width: 1100px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
`;

class CityShare extends PureComponent {
  state = {
    value: "",

    city: null
  };

  render() {
    const { match } = this.props;

    return (
      <PageWrapper>
        <Query query={cityQuery} variables={{ slug: match.params.city }}>
          {({ loading, error, data }) => {
            if (loading || !data) return <Loading text="City query" />;

            const city = data.cityBySlug;
            this.setState({ city });

            let party = null;

            city.parties.forEach(p => {
              if (p.slug === match.params.party) {
                party = p;
              }
            });

            return (
              <PartyWrapper id="shareEl">
                {party.emojis.map(row => (
                  <div key={row.id} style={{ margin: "20px" }}>
                    <Emoji allowNative={true}>{row.emoji}</Emoji>
                  </div>
                ))}
              </PartyWrapper>
            );
          }}
        </Query>
      </PageWrapper>
    );
  }
}

export default CityShare;



// WEBPACK FOOTER //
// ./src/pages/Share/Party.js